import React, { PureComponent } from 'react';
import { DateTime } from 'luxon';

import { Event } from '@interfaces/outreach-entity';
import { formatDateInterval } from 'client/helpers/date';
import EventItemHorizontal from '@components/event-item/event-item-horizontal';
import EventItemVertical from '@components/event-item/event-item-vertical';

interface Props {
    entity: Event;
    type: 'horizontal' | 'vertical';
}

export default class EventItem extends PureComponent<Props> {
    public get isCompleted() {
        const { entity } = this.props;
        const { date, dateEnd } = entity;
        const now = DateTime.local();
        const DateToCompare = dateEnd || date;

        return DateTime.fromISO(DateToCompare) < now;
    }

    public get dateInterval() {
        const { entity } = this.props;
        const { date, dateEnd } = entity;

        return formatDateInterval(date, dateEnd);
    }

    public render() {
        const { entity, type } = this.props;
        const TypedEventItem = (type === 'horizontal') ? EventItemHorizontal : EventItemVertical;

        return (
            <TypedEventItem
                entity={entity}
                isCompleted={this.isCompleted}
                dateInterval={this.dateInterval}
            />
        );
    }
}
